import React from 'react';
import { Provider } from 'react-redux';
import store from '@state/store';
import { AddToCartLayer } from './AddToCartLayer';

export const ProvideAddToCartLayer = () => {
  return (
    <Provider store={store}>
      <AddToCartLayer />
    </Provider>
  );
};
